"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function LoadingCover(props) {
    return React.createElement("div", { className: "loading-cover" + (props.active ? " loading-cover-active" : ""), style: { display: (props.active ? "flex" : "none"), justifyContent: "center", alignItems: "center" } },
        React.createElement("div", { className: "loading-spinner" }));
}
exports.LoadingCover = LoadingCover;
